export default "__VITE_ASSET__2db252f0__"